import { NavLink } from 'react-router-dom';

export function AdminNav() {
  return (
    <nav className="admin-subnav" aria-label="Admin sections">
      <NavLink to="/admin" end>Overview</NavLink>
      <NavLink to="/admin/rooms">Rooms</NavLink>
      <NavLink to="/admin/devices">Devices</NavLink>
      <NavLink to="/admin/health">Health</NavLink>
    </nav>
  );
}
